import { useQuery } from '@tanstack/react-query';
import { Dropdown, Table, TableColumnsType } from 'antd';
import { getEmailTemplates } from './request';
import { ReactComponent as Ellipsis } from '../../../assets/ellipsis.svg';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';

const EmailTemplates = () => {
  const navigate = useNavigate();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['emailTemplates'],
    queryFn: getEmailTemplates,
  });

  const templates = data?.data as EmailTemplate[];
  const columns: TableColumnsType<EmailTemplate> = [
    {
      title: 'S/N',
      dataIndex: 'key',
      key: 'sn',
      render: (_text, _record, index) => index + 1,
    },
    {
      title: 'Template Name',
      dataIndex: 'code',
      key: 'name',
    },
    {
      title: 'Status',
      dataIndex: 'activeStatus',
      key: 'status',
      render: (_, record) => (record.activeStatus ? 'Active' : 'Inactive'),
    },
    {
      key: 'action',
      title: 'Action',
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: 'View',
                key: '1',
                onClick: () => {
                  navigate(`/email-templates/${record.id}`);
                },
              },
            ],
          }}
          trigger={['click']}
        >
          <Ellipsis />
        </Dropdown>
      ),
    },
  ];
  return (
    <div>
      <h1>Email Templates</h1>
      <Table
        dataSource={templates}
        columns={columns}
        rowKey="id"
        loading={isLoading}
        locale={{
          emptyText: isError
            ? (error as AxiosError as any)?.response?.data?.message || 'An error occurred while fetching templates'
            : 'No email templates found',
        }}
      />
    </div>
  );
};

export default EmailTemplates;
